module.exports = __webpack_public_path__ + "static/media/kwihangana_ntarama6.89ed0609.jpg";